import getConfig from "next/config";
import { ArticleLayout } from "types/api";
import { ArticleRenderNotSupported } from "./error";

const { publicRuntimeConfig } = getConfig();

export default function checkArticleRenderSupport({
  article: { layout, isTnfCompatible },
  swanTestGroup,
}: {
  article: { layout: ArticleLayout; isTnfCompatible: boolean };
  swanTestGroup?: boolean;
}) {
  const swanDevMode =
    publicRuntimeConfig.ENABLE_FEATURE_ARTICLE_RENDER === "true";

  if (swanTestGroup) {
    if (!swanDevMode && !isTnfCompatible) {
      // For swan test users, only fall back to ollie if the article is
      // explicitly marked as not frontend compatible
      throw new ArticleRenderNotSupported();
    } else {
      return;
    }
  }

  if (layout === "feature" || !isTnfCompatible) {
    if (!swanDevMode) {
      // In prod, return error; otherwise log a warning
      throw new ArticleRenderNotSupported();
    } else {
      console.warn("Attempting to render an article that may not be supported");
    }
  }
}
